var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDeleteGrey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,1.5 L6.75,2.25 L3,2.25 L3,3.75 L15,3.75 L15,2.25 L11.25,2.25 L10.5,1.5 L7.5,1.5 Z M3.75,5.25 L3.75,15 C3.75,15.825 4.425,16.5 5.25,16.5 L12.75,16.5 C13.575,16.5 14.25,15.825 14.25,15 L14.25,5.25 L3.75,5.25 Z M6,6.75 L7.5,6.75 L7.5,15 L6,15 L6,6.75 Z M10.5,6.75 L12,6.75 L12,15 L10.5,15 L10.5,6.75 Z",
    id: "magorina16"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "magorina15",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magorina",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "magorina4",
    transform: "translate(-934.000000, -117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magorina2",
    transform: "translate(260.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magorina5",
    transform: "translate(21.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magorina6",
    transform: "translate(600.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magorina7",
    transform: "translate(50.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "magorina8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#magorina16"
  })), /*#__PURE__*/React.createElement("use", {
    id: "magorina12",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#magorina16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magorina11",
    mask: "url(#magorina8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "magorina9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "magorina10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#magorina15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "magorina13",
    fill: "#000000",
    xlinkHref: "#magorina15"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDeleteGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_delete_grey.c6b36303.svg";
export { ForwardRef as ReactComponent };